import * as React from "react";

import { LoginAppProvider } from "../../../Common";

export const PdpLoginAppProvider: React.FunctionComponent = (props) => {
  return (
    <LoginAppProvider
      shouldLoginUsingTheSpecialAsynchronousApiInsteadOfFormPost
      shouldContinueLoadingAfterLoginSuccess={false}
    >
      {props.children || []}
    </LoginAppProvider>
  );
};
